import api from 'helpers/api';

export function fetchMyUser() {
  return api.backend.get('user').then(response => response.data.user);
}



// WEBPACK FOOTER //
// ./src/api/users.js